import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import { StarFill, StarHalf } from 'react-bootstrap-icons';
import { useCart, useDispatchCart } from './ContextReducer';


export default function Card({ cardData }) {

    const [quantity, setquantity] = useState(1);

    const data = useCart()
    const dispatch = useDispatchCart()

    const handleAddCart = async () => {
        await dispatch({
            type: "ADD",
            name: cardData.title,
            img: cardData.image,
            price: finalPrice,
            qty: quantity
        })
        console.log(data);
    }

    const finalPrice = cardData.realPrice * quantity

    return (
        <div className='container'>
        <div className='row'>
            <div className='col-12 box pb-4'>
                <div className="card" style={{ width: "100%", height: "450px" }}>
                    <div className="card-body">
                        <div className='d-flex'>
                            <h6 className="card-title " style={{ marginRight: "17rem" }}> {cardData.discount}% </h6>
                            <button className='heart-btn' style={{ border: "none", backgroundColor: "white" }}></button>
                        </div>
                        <img src={cardData.image} style={{ height: "10rem", objectFit: "fill" }} alt="img" />
                        <h3>{cardData.title}</h3>
                        <div className="product-rating">
                            <StarFill />
                            <StarFill />
                            <StarFill />
                            <StarHalf />
                            <StarHalf />
                        </div>
                        <div className='price'>
                            <span className='fake-price'>{cardData.fakePrice * quantity}₹</span>
                            <span className='real-price'>{finalPrice} ₹/-</span>
                        </div>
                        <div className='quantity'>
                            <p>Quantity : </p>
                            <select className='form-select w-auto mb-2 ml-1' value={quantity} onChange={(e) => { setquantity(e.target.value) }}>
                                {Array.from(Array(10), (e, i) => {
                                    return (
                                        <option key={i + 1} value={i + 1}>{i + 1}</option>
                                    )
                                })}
                            </select>
                            <p className='p-2'>Kg</p>
                        </div>
                        <Link to="#" className="btn all-btn button" onClick={handleAddCart}>Add to Card</Link>
                    </div>
                </div>
            </div>
        </div>
    </div>
    )
}
